import {
  IonContent,
  IonHeader,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonItem,
  IonList,
  IonLoading,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
} from '@ionic/react';
import { useCallback, useContext, useEffect, useState } from 'react';
import PageContainer from '../../../components/PageContainer';
import Banner from '../../../components/Banner';
import { AppContext } from '../../../lib/context/AppContext';
import { INotification, Notification } from '../../../lib/models/Notification';
import Toolbar from '../../../components/Toolbar';

const defaultPagination = { start: 0, limit: 20 };

const NotificationsList: React.FC = (props) => {
  const { apiService } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [firstLoading, setFirstLoading] = useState(true);
  let [haveNewItemsToLoad, setHaveNewItemsToLoad] = useState(true);
  let [notifications, setNotifications]: [INotification[], any] = useState([]);
  let [pagination, setPagination] = useState(defaultPagination);

  const getNotifications = useCallback(
    (reset: boolean = false, complete?: () => void) => {
      apiService
        ?.get(
          `/notifications?populate=event,promo,trip,announcement&sort=id:desc&pagination[start]=${pagination.start}&pagination[limit]=${pagination.limit}`
        )
        .then((response: any) => {
          setHaveNewItemsToLoad(
            response.data?.data?.length >= defaultPagination.limit
          );

          setNotifications([
            ...(reset ? [] : notifications),
            ...response.data.data.map((_notification: any) =>
              Notification(_notification)
            ),
          ]);

          if (complete) {
            complete();
          }
        });
    },
    [apiService, pagination]
  );

  useEffect(() => {
    getNotifications(pagination.start === 0, () => {
      setFirstLoading(false);
    });
  }, [apiService, pagination]);

  return (
    <>
      <IonPage>
        <IonHeader>
          <Toolbar title='Notifiche'></Toolbar>
        </IonHeader>

        <IonContent fullscreen>
          <IonLoading spinner='bubbles' isOpen={firstLoading} />

          <IonRefresher
            slot='fixed'
            onIonRefresh={(ev) => {
              setPagination(defaultPagination);
              ev.detail.complete();
            }}
          >
            <IonRefresherContent></IonRefresherContent>
          </IonRefresher>

          <PageContainer>
            {notifications.length === 0 && !loading && !firstLoading && (
              <Banner title='' message='Nessuna notifica' className='mt-8' />
            )}
            {notifications && (
              <>
                <IonList lines='full'>
                  {notifications?.map(
                    (notification: INotification, index: number) => (
                      <IonItem
                        key={index}
                        onClick={() => {
                          let notificationObject = {
                            modelType: '',
                            modelId: 0,
                          };
                          if (notification.event?.id) {
                            notificationObject = {
                              modelType: 'event',
                              modelId: notification.event.id,
                            };
                          } else if (notification.promo?.id) {
                            notificationObject = {
                              modelType: 'promo',
                              modelId: notification.promo.id,
                            };
                          } else if (notification.announcement?.id) {
                            notificationObject = {
                              modelType: 'announcement',
                              modelId: notification.announcement.id,
                            };
                          } else if (notification.trip?.id) {
                            notificationObject = {
                              modelType: 'trip',
                              modelId: notification.trip.id,
                            };
                          }

                          window.document.dispatchEvent(
                            new CustomEvent('openNotification', {
                              detail: {
                                internalLink: true,
                                ...notificationObject,
                              },
                            })
                          );
                        }}
                      >
                        <div className='flex flex-col py-3'>
                          <h3>{notification.title}</h3>
                          <p>{notification.message}</p>
                        </div>
                      </IonItem>
                    )
                  )}
                </IonList>

                {haveNewItemsToLoad && !loading && (
                  <IonInfiniteScroll
                    onIonInfinite={(ev) => {
                      const _pagination = {
                        ...pagination,
                        start: pagination.start + pagination.limit,
                      };
                      setPagination(_pagination);
                      ev.target.complete();
                    }}
                  >
                    <IonInfiniteScrollContent></IonInfiniteScrollContent>
                  </IonInfiniteScroll>
                )}
              </>
            )}
          </PageContainer>
        </IonContent>
      </IonPage>
    </>
  );
};

export default NotificationsList;
